import React from 'react';
import { IconButton, Icon } from '@mui/material';
import { useSnackbar, SnackbarKey } from 'notistack';

interface SnackbarCloseButtonProps {
  snackbarKey: SnackbarKey;
}

const SnackbarCloseButton = ({ snackbarKey }: SnackbarCloseButtonProps) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton size="small" onClick={() => closeSnackbar(snackbarKey)} sx={{ color: 'inherit' }}>
      <Icon fontSize="small">close</Icon>
    </IconButton>
  );
};

export default SnackbarCloseButton;
